module.exports = __webpack_public_path__ + "static/img/foketi-salesi.371a65c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/foketi-salesi.jpg
// module id = VvME
// module chunks = 0